"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    icon: _propTypes.default.string.isRequired,
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    fontsize: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
    top: _propTypes.default.string,
    right: _propTypes.default.string,
    left: _propTypes.default.string,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    color: _constant.DEFAULT_COLOR,
    fontsize: 'XSmall',
    icon: 'FlightIcon',
    accessible: true,
    top: '0',
    right: '0',
    left: '0'
  }
};
exports.default = _default;